/**
 * 持卡人 / 账户字段的前端正则校验集合
 * 与 PRD §3 持卡人资料合规校验保持一致
 */

/** 仅允许英文字母与连字符、空格，长度 1~40 */
export const NAME_REGEX = /^[A-Za-z][A-Za-z\-' ]{0,39}$/;

/** 邮箱（业界宽松版） */
export const EMAIL_REGEX = /^[\w!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

/** 国际区号格式：+ 开头，1~3 位国家码 + 4~14 位号码（可含 - 或空格分隔） */
export const PHONE_INTL_REGEX = /^\+\d{1,3}[\d\- ]{4,18}$/;

/** ISO 3166-1 两位大写字母 */
export const COUNTRY_CODE_REGEX = /^[A-Z]{2}$/;

/** 邮编：宽松版（4~10 位字母数字） */
export const POSTAL_CODE_REGEX = /^[A-Za-z0-9\- ]{4,10}$/;

export function isValidName(value: string): boolean {
  return NAME_REGEX.test(value);
}
export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value);
}
export function isValidIntlPhone(value: string): boolean {
  return PHONE_INTL_REGEX.test(value);
}
